import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-md w-full" }
const _hoisted_3 = { class: "bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between rounded-t-lg" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex-shrink-0 w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-900/20 flex items-center justify-center mr-3" }
const _hoisted_6 = { class: "px-6 py-6" }
const _hoisted_7 = { class: "mb-6 p-4 bg-gray-50 dark:bg-black/50 rounded-lg" }
const _hoisted_8 = { class: "text-base font-semibold text-gray-900 dark:text-white" }
const _hoisted_9 = { class: "text-sm text-gray-600 dark:text-gray-400 mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg"
}
const _hoisted_11 = { class: "text-sm text-red-600 dark:text-red-400" }
const _hoisted_12 = { class: "bg-gray-50 dark:bg-black/50 px-6 py-4 flex items-center justify-end space-x-3 rounded-b-lg" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import type { Customer } from '@/types/customer';
import LockIcon from '@/components/icons/LockIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordModal',
  props: {
    isOpen: { type: Boolean },
    customer: {},
    loading: { type: Boolean },
    error: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.customer)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(LockIcon, { classes: "h-5 w-5 text-purple-600 dark:text-purple-400" })
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Reset Password ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[5] || (_cache[5] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-1" }, "Customer", -1)),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.customer.first_name) + " " + _toDisplayString(_ctx.customer.last_name), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.customer.email), 1)
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mb-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg" }, [
                      _createElementVNode("div", { class: "flex" }, [
                        _createElementVNode("div", { class: "flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "h-5 w-5 text-yellow-400",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            })
                          ])
                        ]),
                        _createElementVNode("div", { class: "ml-3" }, [
                          _createElementVNode("h3", { class: "text-sm font-medium text-yellow-800 dark:text-yellow-400" }, " Important Notice "),
                          _createElementVNode("div", { class: "mt-2 text-sm text-yellow-700 dark:text-yellow-300" }, [
                            _createElementVNode("p", null, "This action will:"),
                            _createElementVNode("ul", { class: "list-disc list-inside mt-1 space-y-1" }, [
                              _createElementVNode("li", null, "Send reset password instructions to the customer's email"),
                              _createElementVNode("li", null, "Require the customer to change their password on next login")
                            ])
                          ])
                        ])
                      ])
                    ], -1)),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.error), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-6" }, " Are you sure you want to reset the password for this customer? ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                      disabled: _ctx.loading,
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Cancel ", 8, _hoisted_13),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm'))),
                      disabled: _ctx.loading,
                      class: "px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[9] || (_cache[9] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Resetting...' : 'Reset Password'), 1)
                    ], 8, _hoisted_14)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})